<div class="identification-mode">
  <div class="identification-mode__content">
    <app-header />

    <div class="identification-mode__main">
      <!--
        Le H1 porte le PARCOURS et le sous-titre porte la question — l'inverse de
        l'accueil, et c'est volontaire : ici, l'information la plus importante
        n'est plus « que fais-je ? » mais « suis-je dans le bon parcours ? ».
      -->
      <section class="identification-mode__hero" aria-labelledby="identification-mode-title">
        <h1 id="identification-mode-title" class="identification-mode__title">
          {{ copy().title }}
        </h1>
        <p class="identification-mode__subtitle">Comment souhaitez-vous vous identifier ?</p>
      </section>

      <section class="identification-mode__cards" aria-label="Mode d'identification">
        <div class="identification-mode__cards-row">
          <div class="identification-mode__card">
            <app-identification-card
              variant="qr"
              title="J'ai un QR code"
              [subtitle]="copy().qrSubtitle"
              illustrationSrc="assets/img/icon-illustration-qr-phone.svg"
              illustrationAlt="Main tenant un smartphone affichant un QR code"
              (pressed)="onQrPressed()"
            />
          </div>

          <div class="identification-mode__card">
            <app-identification-card
              variant="manual"
              title="Je n'ai pas de QR code"
              [subtitle]="copy().manualSubtitle"
              illustrationSrc="assets/img/icon-illustration-manual-keypad.svg"
              illustrationAlt="Main pointant vers un clavier"
              (pressed)="onManualPressed()"
            />
          </div>
        </div>
      </section>
    </div>

    <app-footer>
      <app-footer-nav [showScrollButton]="false" backRoute="/" />
    </app-footer>
  </div>
</div>
